import { all, call, put, takeLatest } from 'redux-saga/effects';
import envConfig from '../../config';

import {
  getDashboardEmbedURL,
  getSessionEmbedURL,
} from '../routines/reportingRoutines';
import { request } from '../../common/util/RestClient';

export function* getDashboardEmbedURLSaga({ payload }) {
  try {
    const URL = `${envConfig.APIG_URL}reporting/users/${payload.username}/defaultDashboard`;
    const response = yield call(request, URL);
    yield put(getDashboardEmbedURL.success(response.data));
  } catch (error) {
    yield put(getDashboardEmbedURL.failure({ error }));
  } finally {
    yield put(getDashboardEmbedURL.fulfill());
  }
}

export function* getSessionEmbedURLSaga({ payload }) {
  try {
    const URL = `${envConfig.APIG_URL}reporting/users/${payload.username}/consoles`;
    const response = yield call(request, URL);
    yield put(getSessionEmbedURL.success(response.data));
  } catch (error) {
    yield put(getSessionEmbedURL.failure({ error }));
  } finally {
    yield put(getSessionEmbedURL.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(getDashboardEmbedURL.TRIGGER, getDashboardEmbedURLSaga),
    takeLatest(getSessionEmbedURL.TRIGGER, getSessionEmbedURLSaga),
  ]);
}
